import "./crm.css";

// The persistent sidebar + topbar now live in <PortalShell> (App.jsx) so they
// are consistent across every portal page. CRMLayout is just a light padded
// wrapper kept for the dashboard's content. Padding / density are handled in
// crm.css so they can respond to the viewport.
export default function CRMLayout({ children }) {
  return <div className="crm-layout">{children}</div>;
}
